//
// Game
//
// Plumbs components together once they have all loaded

game = {};
gameData = {};
gameData.gameName = 'Piggies Prize Party';
gameData.gameNameShort = 'PPP';
gameData.gameVersionMajor = '1';
gameData.gameVersionMinor = '0';
gameData.gameVersionBugFix = '2';
gameData.gameReleaseDate = '26/05/26'; // update me upon release
gameData.version = '' + gameData.gameVersionMajor + '.' + gameData.gameVersionMinor + '.' + gameData.gameVersionBugFix;

gameData.symbolWidth = 150;
gameData.symbolHeight = 130;
gameData.appertureSize = 140;
gameData.numReels = 5;
gameData.numRows = 3;
game.features = [];
game.currentFeature = 0;
game.maxFeatureIndex = 2;
game.featureAnimating = false;
game._autoClickForReplayRewatchTimer = undefined;

// Readonly constants to help eliminate magic numbers in the code
Object.defineProperty(gameData, 'NUM_REELS', {
  value: gameData.numReels,
  writable: false,
  enumerable: true,
  configurable: false,
});

Object.defineProperty(gameData, 'NUM_ROWS', {
  value: gameData.numRows,
  writable: false,
  enumerable: true,
  configurable: false,
});

Object.defineProperty(gameData, 'LAST_REEL_INDEX', {
  value: gameData.numReels - 1,
  writable: false,
  enumerable: true,
  configurable: false,
});

Object.defineProperty(gameData, 'LAST_ROW_INDEX', {
  value: gameData.numRows - 1,
  writable: false,
  enumerable: true,
  configurable: false,
});

Object.defineProperty(gameData, 'GRID_SIZE', {
  value: gameData.numReels * gameData.numRows,
  writable: false,
  enumerable: true,
  configurable: false,
});

gameData.themeTuneId = undefined;
gameData.freespinsThemeTuneId = undefined;
gameData.mainTunePlaying = false;
game.sideMenuOpen = false;

game.currentFeature = 0;
game.featureAnimating = false;
game.featureAutoTimeline = undefined;
game.timeScale = 1;

game.swapFeature = function (direction) {
  if (game.featureAnimating) return;

  game.featureAnimating = true;

  // game.arrows.forEach((arrow) => {
  //   arrow.alpha = 0.7;
  // });

  const duration = 0.2;
  const offset = 100;
  const oldCont = game.features[game.currentFeature];
  oldCont.visible = true;

  gsap.to(oldCont, {
    duration,
    x: offset * direction,
    alpha: 0,
    onComplete: () => {
      oldCont.visible = false;
    },
  });

  game.currentFeature += direction;

  if (game.currentFeature < 0) {
    game.currentFeature = game.maxFeatureIndex;
  } else if (game.currentFeature > game.maxFeatureIndex) {
    game.currentFeature = 0;
  }

  const newCont = game.features[game.currentFeature];
  newCont.x = offset * -direction;
  newCont.visible = true;
  newCont.alpha = 0;

  gsap.to(newCont, {
    duration,
    delay: duration / 2,
    x: 0,
    alpha: 1,
    onComplete: () => {
      game.featureAnimating = false;
      // game.arrows.forEach((arrow) => {
      //   arrow.alpha = 1;
      // });
    },
  });
};

game.showCurrentFeature = function () {
  game.features.forEach((feature) => {
    feature.visible = false;
    feature.alpha = 0;
  });

  game.features[game.currentFeature].visible = true;
  game.features[game.currentFeature].alpha = 1;
};

gameData.convertStringToSegmentId = function (str) {
  switch (str) {
    case 'segmentGreen': {
      return gameData.segmentDollar;
    }
    case 'segmentYellow': {
      return gameData.segmentBigWin;
    }
    case 'segmentBlue': {
      return gameData.segmentBonus;
    }
    case 'segmentRed': {
      return gameData.segmentFreespins;
    }
    case 'fsSegmentMega': {
      return gameData.fsSegmentMega;
    }
    case 'fsSegmentSuper': {
      return gameData.fsSegmentSuper;
    }
    case 'fsSegmentMidi': {
      return gameData.fsSegmentMidi;
    }
    case 'fsSegmentMinor': {
      return gameData.fsSegmentMinor;
    }
    case 'fsSegmentMini': {
      return gameData.fsSegmentMini;
    }
    case 'fsSegment3Fs': {
      return gameData.fsSegment3Fs;
    }
    case 'fsSegment5Fs': {
      return gameData.fsSegment5Fs;
    }
    case 'fsSegment8Fs': {
      return gameData.fsSegment8Fs;
    }
    default: {
      console.log('');
    }
  }
};

game.autoplayPopupOpen = false;

game.splashScreenDone = false;

// Reflex.enableDeveloperMode();
//Reflex.developerModeData.createTestLanguages = true;
// Reflex.developerModeData.highlightTranslatedText = true;

game.onCreditChanged = function (creditTask) {
  gameData.credit = creditTask.data.balance;
  // SRB - Balance
  // let credit = creditTask.data.balance;
  // if (
  //   gdk.serverParser._inReplayMode === true &&
  //   gdk.serverParser._endGame === true &&
  //   typeof gdk.serverParser.prepaidResultBalance === 'number' &&
  //   gdk.serverParser.prepaidResultBalance !== 0
  // ) {
  //   credit = gdk.serverParser.prepaidResultBalance;
  // }
  gameData.creditMeter.set(gameData.credit);
};

game.createGameVersion = function () {
  var versionString =
    gameData.gameName +
    ' v' +
    gameData.gameVersionMajor +
    '.' +
    +gameData.gameVersionMinor +
    '.' +
    gameData.gameVersionBugFix;
  Debug.log(versionString);
};

game.initialise = function (gameConfigTask) {
  // --------------------------------------------------------------------------------------------
  // All game data has been loaded, initial layout has been set, and gameData has been populated.
  // Time to link everything together.
  // --------------------------------------------------------------------------------------------
  var i;

  // Create the game version text
  game.createGameVersion();

  gameData.gameConfig = gameConfigTask.data;

  // Set initial state
  resourceManager.getController('inputOverlord').setState('enabled');

  // Hide all screens except loading. These will be shown when loading continues
  resourceManager.getContainer('gameContainer').visible = false;
  resourceManager.getContainer('DemoContainer').visible = false;
  resourceManager.getContainer('gameButtonContainer').visible = false;
  // resourceManager.getContainer("specialButtonContainer").visible = false;

  gameData.stakes = [];
  gameData.coinSizes = [];
  gameData.currentStakeIndex = gameConfigTask.data.slotConfig.coinSizes.indexOf(
    gameConfigTask.data.slotConfig.defaultAmountPerLine
  );
  gameData.numLines = gameConfigTask.data.slotConfig.defaultNumLines;
  for (i = 0; i < gameConfigTask.data.slotConfig.coinSizes.length; i++) {
    gameData.stakes.push(gameConfigTask.data.slotConfig.coinSizes[i] * gameConfigTask.data.slotConfig.defaultNumLines);
    gameData.coinSizes.push(gameConfigTask.data.slotConfig.coinSizes[i]);
  }

  gameData.gameMathsVersion = gameConfigTask.data.mathsVersion;

  gameData.stakeMeter = resourceManager.get('meterContainer:stake:meter');
  gameData.creditMeter = resourceManager.get('meterContainer:credit:meter');
  gameData.winningsMeter = resourceManager.get('meterContainer:winnings:meter');
  gameData.winningsMeterTitle = resourceManager.get('meterContainer:winnings:title');

  gameData.multiplierValues = [2, 3, 4, 5, 10, 20, 50, 100];

  messageBus.subscribe('common:BalanceEvent', game.onCreditChanged);
  messageBus.subscribe('game:modal', game.modal);
  messageBus.subscribe('game:sideMenuOpen', game.sideMenuOpenMsg);
  messageBus.subscribe('game:sideMenuClosed', game.sideMenuClosedMsg);
  messageBus.subscribe('game:backFromReplay', game.backFromReplay);
  Reflex.registerEventHandler('orientationChange', game.onOrientationChange);
  Reflex.registerEventHandler('resize', game.onResize);

  gameController.initialise(gameConfigTask);

  if (gameData.recoveryStake) {
    game.changeStake(gameData.recoveryStake);
    gdk.playerChangedStake(gameData.recoveryStake);
    gameController.inRecovery = true;
    if (gameData.recoveryMode === 'GOLDENBET_BUY') {
      const stakeController = resourceManager.getController('stakeController');
      stakeController.requestChangeStake(gameData.recoveryStake / 1.5);
      resourceManager.get('backgroundButtons:luckyBetToggleButton').toggleOn(true);
    }
  } else if (gameData.previouslyLoadedStakeAndMode != null) {
    const { lastCashStake, lastGameMode } = gameData.previouslyLoadedStakeAndMode;
    // const gameModes = ['BASIC', 'GOLDENBET_BUY', 'BONUSBUY_BUY'];
    if (lastGameMode === 0 || lastGameMode === 1) {
      // only change stake if last mode was default / basic
      game.changeStake(lastCashStake);
      gdk.playerChangedStake(lastCashStake);
    } else {
      game.changeStake(gameData.stakes[gameData.currentStakeIndex]);
      gdk.playerChangedStake(gameData.stakes[gameData.currentStakeIndex]);
    }
    if (lastGameMode === 1) {
      resourceManager.get('backgroundButtons:luckyBetToggleButton').toggleOn();
    }
  } else {
    game.changeStake(gameData.stakes[gameData.currentStakeIndex]);
    gdk.playerChangedStake(gameData.stakes[gameData.currentStakeIndex]);
  }

  // Kick off the game
  game.onOrientationChange();
  gameController.start();
};

game.enableSpeedUp = function () {
  const caller = new Error().stack?.split('\n')[2]?.trim().split(' ')[1];
  if (caller === 'GDK.readyCb') {
    document.addEventListener('keydown', (event) => {
      let validOptionPressed = true;
      if (event.key === '*') {
        game.timeScale += 0.05;
      } else if (event.key === '/') {
        game.timeScale -= 0.05;
      } else if (event.key === '-') {
        game.timeScale = 1;
      } else if (event.key === '0') {
        game.timeScale = 0;
      } else if (event.key === '1') {
        game.timeScale = 0.2;
      } else if (event.key === '2') {
        game.timeScale = 0.4;
      } else if (event.key === '3') {
        game.timeScale = 0.6;
      } else if (event.key === '4') {
        game.timeScale = 0.8;
      } else if (event.key === '5') {
        game.timeScale = 1;
      } else if (event.key === '6') {
        game.timeScale = 1.5;
      } else if (event.key === '7') {
        game.timeScale = 2;
      } else if (event.key === '8') {
        game.timeScale = 3;
      } else if (event.key === '9') {
        game.timeScale = 5;
      } else {
        validOptionPressed = false;
      }

      if (validOptionPressed) {
        if (game.timeScale > 10) game.timeScale = 10;
        if (game.timeScale < 0) game.timeScale = 0;

        console.log('Time scale: ' + game.timeScale.toFixed(2));

        // not sure this bit is needed
        if (Reflex.gamePaused || Reflex.platformPaused) {
          soundManager.pauseAllSounds();
        } else {
          soundManager.resumeAllSounds();
        }
        ///////
        soundManager.setTimeScale(game.timeScale);
        gsap.globalTimeline.timeScale(game.timeScale);
        Reflex.setGameSpeed(game.timeScale);
      }
    });
  }
};

game.backFromReplay = function (data) {
  if (
    soundManager.sharedMode === true // we have been sharing the soundManager
  ) {
    // im going to assume the back button has been pressed during watching a replay
    // the ygg platform is telling us to unmute audio
    // stop any sounds currently playing from the old replay game
    // then clear the sharedMode flag
    // we need to restore what audio and what levels they were playing at
    // this will be down to each client to handle this as ids are stored all over the place
    // the music managers are inconsistant
    soundManager.stopAllSounds();
    soundManager.sharedMode = false;
    messageBus.post('sounds:restorePreviouslyPlayingAudio', {
      reason: 'back from replay',
    });
  }
};

game.sideMenuOpenMsg = function () {
  game.sideMenuOpen = true;
};

game.sideMenuClosedMsg = function () {
  game.sideMenuOpen = false;
};

game.onResize = function () {
  if (gameData.gameMask) {
    if (systemData.isLandscape) {
      gameData.gameMask.scale.x = 1280;
      gameData.gameMask.scale.y = 720;
    } else {
      gameData.gameMask.scale.x = 720;
      gameData.gameMask.scale.y = 1280;
    }
  }
};

game.onOrientationChange = function () {
  if (game.slideShowActive) {
    game.updateSplashScreen();
  }

  if (game.splashScreenDone) {
    switch (layoutController.getCurrentLayout()) {
      case 'landscape_default':
      case 'landscape_mobile': {
        resourceManager.getContainer('backgroundContainer').visible = true;
        resourceManager.getContainer('backgroundContainerPortrait').visible = false;
        break;
      }
      case 'portrait_default':
      case 'portrait_mobile': {
        resourceManager.getContainer('backgroundContainer').visible = false;
        resourceManager.getContainer('backgroundContainerPortrait').visible = true;
        break;
      }
    }
  }
};

game.disableSplashBackgrounds = function (background, portrait_background) {
  background.visible = false;
  background.interactive = false;
  background.on('mouseup', function () {});
  background.on('touchend', function () {});
  portrait_background.visible = false;
  portrait_background.interactive = false;
  portrait_background.on('mouseup', function () {});
  portrait_background.on('touchend', function () {});
};

game.onCloseTutorial = function () {
  game.stopAutoClickForReplayRewatch();
  const bgContainer = resourceManager.getContainer('backgroundContainer');
  bgContainer.visible = true;
  gameData.gameMask = new PIXI.Graphics();
  gameData.gameMask.beginFill(0xffffff);
  gameData.gameMask.lineStyle(0, 0xffffff);
  gameData.gameMask.drawRect(0, 0, 1, 1);
  bgContainer.addChild(gameData.gameMask);

  systemData.gameContainer.mask = gameData.gameMask;

  if (gameData.recoveryStake) {
    let mode = undefined;
    if (gameData.recoveryMode === 'GOLDENBET_BUY') {
      gameData.encoreEnabled = true;
      mode = gameData.recoveryMode;
    } else if (gameData.recoveryMode === 'BONUS_BUY_LOW') {
      mode = gameData.recoveryMode;
      gameController.inBuyABonus = true;
      gameController.buyBonusLow = true;
    } else if (gameData.recoveryMode === 'BONUS_BUY_HIGH') {
      mode = gameData.recoveryMode;
      gameController.inBuyABonus = true;
      gameController.buyBonusHigh = true;
    } else if (gameData.recoveryMode === 'BONUS_BUY_MYSTERY') {
      mode = gameData.recoveryMode;
      gameController.inBuyABonus = true;
      gameController.buyBonusMystery = true;
    }

    const stakeController = resourceManager.getController('stakeController');
    stakeController.requestChangeStake(gameData.recoveryStake / (gameData.encoreEnabled ? 1.5 : 1), mode);
    game.changeStake(gameData.recoveryStake);
  }

  // helper.updateHelpWinlineText();

  game.goToGame();
};

game.goToGame = function () {
  if (gdk.deviceInfo.chrome) {
    var chromeVersion = Number(
      String(gdk.deviceInfo.version).substring(0, String(gdk.deviceInfo.version).indexOf('.'))
    );
    if (chromeVersion >= 55) {
      // Chrome will only start audio on a touch
      Howler.ctx.resume();
    }
  }

  game.slideShowActive = false;

  timerManager.stop(game.slideshowTimer);

  gameData.mainTunePlaying = true;

  resourceManager.getContainer('loadingContainer').visible = false;
  resourceManager.getContainer('gameContainer').visible = true;
  resourceManager.getContainer('msgBoxPopupContainer').visible = true;
  resourceManager.getContainer('gameButtonContainer').visible = true;
  resourceManager.getContainer('particleContainer').visible = true;
  resourceManager.getContainer('buyABonusContainer').visible = true;
  resourceManager.getContainer('settingsMenuContainer').visible = true;
  resourceManager.getContainer('florishContainer').visible = true;
  resourceManager.getContainer('splashContainer').visible = false;
  resourceManager.getContainer('loadingContainer').visible = false;
  resourceManager.get('maxWinPopup').visible = false;
  resourceManager.getContainer('helpPageScrollContainer').visible = true;

  resourceManager.get('mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation').visible = false;

  spineSymbolAnimator.initialise();
  symbolAnimator.initialise();

  gameData.helpPageScroll = resourceManager.get('helpPageScrollContainer:helpPageScroll');
  game.loadingBackgroundLandscape = resourceManager.get('splashBackground1:splashBackgroundL');
  game.loadingBackgroundLandscape.clearInteractiveCallbacks();
  game.loadingBackgroundPortrait = resourceManager.get('splashBackground1:splashBackgroundP');
  game.loadingBackgroundPortrait.clearInteractiveCallbacks();

  resourceManager.getContainer('DemoContainer').visible = true;

  game.onResize();

  game.onOrientationChange();

  game.overrideButtons();
  if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
    gdk.requestFullscreen();
  }

  gameController.splashScreenComplete();

  if (gameController.inRecovery) {
    gameController.initNewGame(true);
  }
};

game.overrideButtons = function () {
  // game.addNonNumpadSpeedControl();

  // const stakeButton = resourceManager.get('buttonContainer:buttonBar:stakeButton');
  // stakeButton.baseCanEnable = stakeButton.canEnable;
  // stakeButton.canEnable = function () {
  //   // are there any pig anims currently in progress?
  //   return this.baseCanEnable() && !gameController.waitingForPigUpdatesToFinish;
  // };

  // const autoplayController = resourceManager.getController('autoplayController');
  // const baseStart = autoplayController.start;
  // const baseCancel = autoplayController.cancel;

  // autoplayController.start = function () {
  //   soundManager.play('buttonPressed');
  //   baseStart();
  // };

  // autoplayController.cancel = function () {
  //   if (game.autoplayPopupOpen) {
  //     soundManager.play('buttonPressed');
  //   }
  //   baseCancel();
  // };

  const spinButton = resourceManager.get('buttonContainer:buttonBar:spinButton');
  // spinButton.canEnableBase = spinButton.canEnable;
  // spinButton.canEnable = function () {
  //   return (
  //     this.canEnableBase() &&
  //     /*!settingsMenu.container.visible &&*/ !helpPageManager.container.visible &&
  //     !game.sideMenuOpen &&
  //     !gameController.inFreeSpins
  //   );
  // };
  spinButton.playSound = function () {
    // musicManager.playSpinButtonSound();
  };
  // const spinButtonPortrait = resourceManager.get('buttonContainerMobile:reflexButtonBar:spinButton_portrait');
  // spinButtonPortrait.canEnableBase = spinButtonPortrait.canEnable;
  // spinButtonPortrait.canEnable = function () {
  //   return (
  //     this.canEnableBase() &&
  //     /*!settingsMenu.container.visible &&*/ !helpPageManager.container.visible &&
  //     !game.sideMenuOpen &&
  //     !gameController.inFreeSpins
  //   );
  // };
  // spinButtonPortrait.playSound = function () {
  //   musicManager.playSpinButtonSound();
  // };

  // const autoplayButton = resourceManager.get('uiContainer:bg:autoplayButton');
  // autoplayButton.baseCanEnable = autoplayButton.canEnable;
  // autoplayButton.canEnable = function () {
  //   return this.baseCanEnable() && !game.sideMenuOpen;
  // };
  // const autoplayButtonPortrait = resourceManager.get('buttonContainerMobile:reflexButtonBar:autoplayButton_portrait');
  // autoplayButtonPortrait.baseCanEnable = autoplayButtonPortrait.canEnable;
  // autoplayButtonPortrait.canEnable = function () {
  //   return this.baseCanEnable() && !game.sideMenuOpen;
  // };

  // const stakeButton = resourceManager.get('uiContainer:bg:stake');
  // stakeButton.baseCanEnable = stakeButton.canEnable;
  // stakeButton.canEnable = function () {
  //   return this.baseCanEnable() && !game.sideMenuOpen;
  // };
  // const stakeButtonPortrait = resourceManager.get('buttonContainerMobile:reflexButtonBar:stake_portrait');
  // stakeButtonPortrait.baseCanEnable = stakeButtonPortrait.canEnable;
  // stakeButtonPortrait.canEnable = function () {
  //   return this.baseCanEnable() && !game.sideMenuOpen;
  // };

  // const volumeButton = resourceManager.get('uiContainer:bg:volume');
  // volumeButton.baseCanEnable = volumeButton.canEnable;
  // volumeButton.canEnable = function () {
  //   return this.baseCanEnable() && !game.sideMenuOpen;
  // };
};

game.modal = function (task) {
  if (task.reason === 'autoplay') {
    game.autoplayPopupOpen = true;
  } else if (task.reason === undefined || task.reason === '') {
    game.autoplayPopupOpen = false;
  }
};

game.addNonNumpadSpeedControl = function () {
  if (gdk.isDevelopmentBuild()) {
    Reflex.developerModeData.keyDownCallbacks.push(function (keycode) {
      if (!Reflex.developerModeData.manipulateCredit) {
        switch (keycode) {
          case 32: {
            // Pause/break key
            Reflex.gamePaused = !Reflex.gamePaused;
            break;
          }
          case 48: {
            // Keypad 0
            Reflex.gamePaused = !Reflex.gamePaused;
            break;
          }
          case 49: {
            // Keypad 1
            Reflex.developerModeData.speedModifier = 0.0625;
            break;
          }
          case 50: {
            // Keypad 2
            Reflex.developerModeData.speedModifier = 0.125;
            break;
          }
          case 51: {
            // Keypad 3
            Reflex.developerModeData.speedModifier = 0.25;
            break;
          }
          case 52: {
            // Keypad 4
            Reflex.developerModeData.speedModifier = 0.5;
            break;
          }
          case 53: {
            // Keypad 5
            Reflex.developerModeData.speedModifier = 1.0;
            break;
          }
          case 54: {
            // Keypad 6
            Reflex.developerModeData.speedModifier = 2.0;
            break;
          }
          case 55: {
            // Keypad 7
            Reflex.developerModeData.speedModifier = 4.0;
            break;
          }
          case 56: {
            // Keypad 8
            Reflex.developerModeData.speedModifier = 8.0;
            break;
          }
          case 57: {
            // Keypad 9
            Reflex.developerModeData.speedModifier = 16.0;
            break;
          }
          case 58: {
            // * key
            Reflex.developerModeData.speedModifier += 0.05;
            break;
          }
          case 59: {
            // / Key
            Reflex.developerModeData.speedModifier -= 0.05;
            break;
          }
          default:
            break;
        }

        if (Reflex.developerModeData.speedModifier > 256) Reflex.developerModeData.speedModifier = 256;
        if (Reflex.developerModeData.speedModifier < 0.00390625) Reflex.developerModeData.speedModifier = 0.00390625;

        if (Reflex.gamePaused || Reflex.platformPaused) {
          soundManager.pauseAllSounds();
        } else {
          soundManager.resumeAllSounds();
        }
        soundManager.setTimeScale(Reflex.developerModeData.speedModifier);
        PIXI.ticker.shared.speed = Reflex.developerModeData.speedModifier;
      }
    });
  }
};

game.changeStake = function (stake) {
  gameData.stakeMeter.set(stake);
  gdk.playerChangedStake(stake);
};

game.onHelpPagesClosed = function () {};

game.onOptionsButtonPressed = function () {
  helpPageManager.showPopup(game.onHelpPagesClosed);
};

game.onAutoplayDialogCancelled = function () {};

game.onAutoplayDialogConfirmed = function () {
  gameController.startAutoplay();
};

game.onAutoplayButtonPressed = function () {
  // If autoplay is running, cancel
  if (autoplayManager.isAutoplayEnabled()) {
    if (gameController.state === 'WAITING_FOR_AUTOPLAY') {
      soundManager.play(gameData.sounds.autoplayCancel);
    } else {
      // We are autoplaying, so wait for autoplay to complete before enabling buttons
      gameData.autoplayButton.enableButton(false);
    }

    autoplayManager.stopAutoplay();
    gameController.cancelAutoplay();

    return;
  }

  // If we are in a waiting state, pop up the auto play interface
  if (gameController.state === 'WAITING_FOR_START') {
    soundManager.play(gameData.sounds.autoplayPress);
    autoplayManager.openDialog(
      game.onAutoplayDialogConfirmed,
      game.onAutoplayDialogCancelled,
      gameData.coinSizes[gameData.currentStakeIndex],
      20
    );
  }
};

// gameData.getSimpleMapData = function (mode, stake) {
//   let data = gameData.mapData.MS.Maps[mode][stake];
//
//   let squareList = [];
//
//   for (let i = 0; i < data.PickLog.length; i++) {
//     let square = data.PickLog[i];
//     let squareID = square.SN;
//     let squareType = square.T;
//
//     let squareData = {
//       type: 'None',
//       wilds: 0,
//       cashVal: 0,
//       cashMultiplier: 0,
//       coinValue: 0,
//       potLevel: undefined,
//       potCash: 0,
//       id: squareID,
//     };
//
//     if (squareType === 'F') {
//       squareData.type = 'FreeSpins';
//     } else if (squareType === 'W') {
//       squareData.type = 'Wild';
//       squareData.wilds = square.SWS;
//     } else if (squareType === 'C') {
//       squareData.type = 'Cash';
//       squareData.coinValue = square.CSA;
//       const stakeController = resourceManager.getController('stakeController');
//       let baseStake = stakeController.BaseStake;
//       squareData.cashVal = square.CSA * (baseStake / 10);
//       squareData.cashMultiplier = squareData.cashVal / baseStake;
//     } else if (squareType === 'P') {
//       squareData.type = 'Pot';
//       squareData.potLevel = square.PSPN;
//       squareData.potCash = square.PSPV;
//     } else {
//       squareData.type = 'Blank';
//     }
//     squareList.push(squareData);
//   }
//   let wildMeter = data.StickyWildMeter;
//   let simpleData = {
//     squareList: squareList,
//     wildMeter: wildMeter,
//   };
//   return simpleData;
// };

gameData.addMapPickToDatabase = function (data, stake, mode) {
  let square = {};
  square.SN = data.squareNumberPicked;
  if (data.squrePicked.type === 'Blank') {
    square.T = 'B';
  } else if (data.squrePicked.type === 'FreeSpins') {
    square.T = 'F';
  } else if (data.squrePicked.type === 'StickyWild') {
    square.T = 'W';
    square.SWS = data.squrePicked.count;
  } else if (data.squrePicked.type === 'Cash') {
    square.T = 'C';
    square.CSA = data.winAmount;
  } else if (data.squrePicked.type === 'Pot') {
    square.T = 'P';
    square.PSPN = data.squrePicked.potName;
    square.PSPV = data.squrePicked.potValue;
  }
  gameData.mapData.MS.Maps[mode][stake].PickLog.push(square);
  gameData.mapData.MS.Maps[mode][stake].StickyWildMeter += data.stickyWildMeterIncrement;
};

gameData.resetMapLayout = function (data, stake, mode) {
  let newData = data.MS.Maps[mode][stake];
  gameData.mapData.MS.Maps[mode][stake].PickLog = [];

  let pickLog = [];
  for (let i = 0; i < newData.PickLog.length; i++) {
    let squareData = {
      SN: newData.PickLog[i].SN,
      T: newData.PickLog[i].T,
    };
    pickLog.push(squareData);
  }
  let newMap = {
    StickyWildMeter: newData.StickyWildMeter,
    PickLog: pickLog,
  };
  gameData.mapData.MS.Maps[mode][stake] = newMap;
};

game.tweenFromToAsync = async function (targets, fromVars, toVars, tweenInfo = null) {
  let resolver = null;
  const tweenPromise = new Promise((resolve) => {
    resolver = resolve;
  });

  const origOnComplete = toVars.onComplete;
  toVars.paused = true;
  toVars.onComplete = () => {
    if (origOnComplete) {
      origOnComplete();
    }
    resolver();
  };

  const tween = gsap.fromTo(targets, fromVars, toVars);
  tween.time(0).restart(true);

  if (tweenInfo) {
    tweenInfo.tween = tween;
    tweenInfo.resolver = resolver;
    tweenInfo.promise = tweenPromise;
  }

  return tweenPromise;
};

game.autoClickForReplayRewatch = function (cb, time = 4000) {
  if (gdk.serverParser._inReplayMode || gdk.serverParser._inRewatchMode) {
    game.stopAutoClickForReplayRewatch(); // just in case
    game._autoClickForReplayRewatchTimer = timerManager.addTimeout(time, cb);
  }
};

game.stopAutoClickForReplayRewatch = function () {
  if (game._autoClickForReplayRewatchTimer) {
    timerManager.stop(game._autoClickForReplayRewatchTimer);
    game._autoClickForReplayRewatchTimer = undefined;
  }
};

timerManager.delayAsync = async function (time, tickCallback, completeCallback, data) {
  if (!tickCallback) {
    tickCallback = (progress) => {};
  }
  if (!completeCallback) {
    completeCallback = () => {};
  }
  // cant expire it early at the moment!!!!!
  let resolver = null;
  const promise = new Promise((resolve) => {
    resolver = resolve;
  });

  const completeCB = () => {
    completeCallback();
    resolver();
  };

  const timer = timerManager.addDelayedTimer(0, time, tickCallback, completeCB, data);

  await promise;
};
